export default {
	setData(state, payload) {
		state.data = payload;
	},

	setAccountsList(state, payload) {
		state.accountsList = payload;
	}
}
